module.exports = __webpack_public_path__ + "img/18_12.c410d95d.png";